import React, { useState, useEffect } from "react";
import { Save, Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";

const INPUT = "w-full px-3 py-2 rounded-lg border outline-none focus:ring-2 text-sm";
const BORDER = { borderColor: "#dcfce7" };

function ListEditor({ label, items, onChange, placeholder }) {
  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-1">{label}</label>
      <div className="space-y-2">
        {items.map((val, idx) => (
          <div key={idx} className="flex gap-2">
            <input className={INPUT} style={BORDER} value={val} placeholder={placeholder}
              onChange={(e) => { const n = [...items]; n[idx] = e.target.value; onChange(n); }} />
            <button type="button" onClick={() => onChange(items.filter((_, i) => i !== idx))}
              className="p-2 rounded-lg bg-red-50 text-red-600 flex-shrink-0"><Trash2 size={16} /></button>
          </div>
        ))}
        <button type="button" onClick={() => onChange([...items, ""])}
          className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#198530" }}>
          <Plus size={14} /> Tambah item
        </button>
      </div>
    </div>
  );
}

export default function RegistrationAdmin() {
  const [info, setInfo] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/registration-info").then((res) => setInfo(res.data));
  }, []);

  if (!info) return <p className="text-gray-400 py-10 text-center">Memuat...</p>;

  const set = (key, val) => setInfo({ ...info, [key]: val });

  const setCost = (idx, key, val) => {
    const costs = [...info.costs];
    costs[idx] = { ...costs[idx], [key]: val };
    setInfo({ ...info, costs });
  };
  const addCost = () => setInfo({ ...info, costs: [...info.costs, { item: "", normal: "", bayar: "", note: "" }] });
  const removeCost = (idx) => setInfo({ ...info, costs: info.costs.filter((_, i) => i !== idx) });

  const setPromo = (idx, key, val) => {
    const promos = [...info.promos];
    promos[idx] = { ...promos[idx], [key]: val };
    setInfo({ ...info, promos });
  };
  const addPromo = () => setInfo({ ...info, promos: [...info.promos, { title: "", desc: "", badge: "" }] });
  const removePromo = (idx) => setInfo({ ...info, promos: info.promos.filter((_, i) => i !== idx) });

  const save = async () => {
    setSaving(true);
    setMsg("");
    try {
      await api.put("/registration-info", info);
      setMsg("Tersimpan!");
      setTimeout(() => setMsg(""), 2500);
    } catch (err) {
      setMsg("Gagal menyimpan");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-registration" className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-gray-900">Info Pendaftaran</h2>
        <div className="flex items-center gap-3">
          {msg && <span className="text-sm font-semibold" style={{ color: "#198530" }}>{msg}</span>}
          <button onClick={save} disabled={saving} data-testid="registration-save"
            className="inline-flex items-center gap-2 text-white px-5 py-2.5 rounded-lg text-sm font-bold disabled:opacity-60" style={{ backgroundColor: "#198530" }}>
            <Save size={16} /> {saving ? "Menyimpan..." : "Simpan Perubahan"}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl border p-5 space-y-4" style={BORDER}>
        <h3 className="font-bold text-gray-800">Header</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div><label className="block text-sm font-semibold text-gray-700 mb-1">Judul</label><input className={INPUT} style={BORDER} value={info.headline} onChange={(e) => set("headline", e.target.value)} /></div>
          <div><label className="block text-sm font-semibold text-gray-700 mb-1">Sub Judul</label><input className={INPUT} style={BORDER} value={info.subtitle} onChange={(e) => set("subtitle", e.target.value)} /></div>
          <div><label className="block text-sm font-semibold text-gray-700 mb-1">Teks Status</label><input className={INPUT} style={BORDER} value={info.status_text} onChange={(e) => set("status_text", e.target.value)} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="block text-sm font-semibold text-gray-700 mb-1">Kuota</label><input className={INPUT} style={BORDER} value={info.quota} onChange={(e) => set("quota", e.target.value)} /></div>
            <div><label className="block text-sm font-semibold text-gray-700 mb-1">Label Kuota</label><input className={INPUT} style={BORDER} value={info.quota_label} onChange={(e) => set("quota_label", e.target.value)} /></div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border p-5 space-y-4" style={BORDER}>
        <div className="grid md:grid-cols-2 gap-6">
          <ListEditor label="Program Unggulan" items={info.programs} onChange={(v) => set("programs", v)} placeholder="Nama program" />
          <ListEditor label="Ekstrakurikuler" items={info.extracurriculars} onChange={(v) => set("extracurriculars", v)} placeholder="Nama ekskul" />
        </div>
        <ListEditor label="Syarat Pendaftaran" items={info.requirements} onChange={(v) => set("requirements", v)} placeholder="Syarat" />
      </div>

      <div className="bg-white rounded-xl border p-5 space-y-3" style={BORDER}>
        <div className="flex items-center justify-between"><h3 className="font-bold text-gray-800">Biaya Pendidikan</h3>
          <button type="button" onClick={addCost} className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#198530" }}><Plus size={14} /> Baris</button></div>
        {info.costs.map((c, idx) => (
          <div key={idx} className="grid grid-cols-12 gap-2 items-center">
            <input className={INPUT + " col-span-4"} style={BORDER} placeholder="Keterangan" value={c.item} onChange={(e) => setCost(idx, "item", e.target.value)} />
            <input className={INPUT + " col-span-2"} style={BORDER} placeholder="Normal" value={c.normal} onChange={(e) => setCost(idx, "normal", e.target.value)} />
            <input className={INPUT + " col-span-2"} style={BORDER} placeholder="Dibayar" value={c.bayar} onChange={(e) => setCost(idx, "bayar", e.target.value)} />
            <input className={INPUT + " col-span-3"} style={BORDER} placeholder="Catatan" value={c.note} onChange={(e) => setCost(idx, "note", e.target.value)} />
            <button type="button" onClick={() => removeCost(idx)} className="col-span-1 p-2 rounded-lg bg-red-50 text-red-600 flex justify-center"><Trash2 size={16} /></button>
          </div>
        ))}
        <div><label className="block text-sm font-semibold text-gray-700 mb-1 mt-2">Total yang Dibayar</label><input className={INPUT} style={BORDER} value={info.total_text} onChange={(e) => set("total_text", e.target.value)} /></div>
      </div>

      <div className="bg-white rounded-xl border p-5 space-y-3" style={BORDER}>
        <div className="flex items-center justify-between"><h3 className="font-bold text-gray-800">Promo Spesial</h3>
          <button type="button" onClick={addPromo} className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#198530" }}><Plus size={14} /> Promo</button></div>
        {info.promos.map((p, idx) => (
          <div key={idx} className="border rounded-lg p-3 space-y-2" style={BORDER}>
            <div className="grid grid-cols-2 gap-2">
              <input className={INPUT} style={BORDER} placeholder="Judul promo" value={p.title} onChange={(e) => setPromo(idx, "title", e.target.value)} />
              <input className={INPUT} style={BORDER} placeholder="Badge" value={p.badge} onChange={(e) => setPromo(idx, "badge", e.target.value)} />
            </div>
            <div className="flex gap-2">
              <textarea className={INPUT} style={BORDER} rows={2} placeholder="Deskripsi" value={p.desc} onChange={(e) => setPromo(idx, "desc", e.target.value)} />
              <button type="button" onClick={() => removePromo(idx)} className="p-2 rounded-lg bg-red-50 text-red-600 flex-shrink-0"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl border p-5 space-y-4" style={BORDER}>
        <h3 className="font-bold text-gray-800">Waktu & Tempat</h3>
        <div><label className="block text-sm font-semibold text-gray-700 mb-1">Waktu Pendaftaran</label><input className={INPUT} style={BORDER} value={info.waktu} onChange={(e) => set("waktu", e.target.value)} /></div>
        <div><label className="block text-sm font-semibold text-gray-700 mb-1">Tempat Pendaftaran</label><textarea className={INPUT} style={BORDER} rows={2} value={info.tempat} onChange={(e) => set("tempat", e.target.value)} /></div>
      </div>
    </div>
  );
}
